import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';
import Navbar from '../components/Navbar';
import { ToastContainer } from '../components/Toast';
import { useToast } from '../hooks/useToast';
import '../styles/Regalos.css';
import '../styles/Extras.css';

// Verificación con selfie: se compara automáticamente con la foto de perfil, sin pasar por el admin
export default function VerificacionPage() {
  const { refreshUser } = useAuth();
  const navigate = useNavigate();
  const { toasts, success, error } = useToast();
  const [estado, setEstado] = useState(null);
  const [archivo, setArchivo] = useState(null);
  const [vista, setVista] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [motivo, setMotivo] = useState('');

  const cargar = useCallback(() => api.verificacionEstado()
    .then(setEstado)
    .catch(e => error(e.message || 'No se pudo cargar la verificación.')), [error]);

  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => () => { if (vista) URL.revokeObjectURL(vista); }, [vista]);

  const elegir = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setArchivo(f);
    setVista(URL.createObjectURL(f));
    setMotivo('');
  };

  const enviar = async () => {
    if (!archivo) return;
    setEnviando(true); setMotivo('');
    const fd = new FormData();
    fd.append('selfie', archivo);
    try {
      await api.enviarSelfie(fd);
      await refreshUser();
      success('✔️ ¡Listo! Tu perfil ya está verificado.');
      cargar();
    } catch (e) {
      setMotivo(e.message || 'No pudimos verificarte. Probá de nuevo.');
      setArchivo(null); setVista(null);
      cargar(); // trae una pose nueva
    } finally { setEnviando(false); }
  };

  return (
    <div className="regalos-page">
      <Navbar />
      <ToastContainer toasts={toasts} />
      <div className="regalos-container container verif-container">
        <h1 className="regalos-title" style={{ marginBottom: 8 }}>✔️ Verificá tu perfil</h1>
        <p className="regalos-sub" style={{ marginBottom: 24 }}>
          Sacate una selfie haciendo el gesto que te pedimos. La comparamos al instante con tu foto de perfil
          y, si sos vos, aparece el ✔️ azul en tu perfil. La selfie no se guarda ni se muestra a nadie.
        </p>

        {!estado ? <p className="regalos-empty">Cargando…</p>
        : estado.verificado ? (
          <div className="verif-caja verif-ok">
            <div className="verif-icono">✔️</div>
            <h2>Tu perfil está verificado</h2>
            <p>Los demás ven el ✔️ azul junto a tu nombre. Si cambiás tu foto principal, vas a tener que verificarte de nuevo.</p>
            <button className="btn btn-primary" onClick={() => navigate('/explorar')}>Ir a Explorar</button>
          </div>
        ) : !estado.tiene_foto ? (
          <div className="verif-caja">
            <p>Primero subí una foto de perfil donde se te vea bien la cara.</p>
            <button className="btn btn-primary" onClick={() => navigate('/perfil/setup')}>Subir mi foto</button>
          </div>
        ) : !estado.disponible ? (
          <div className="verif-caja">
            <p>La verificación no está disponible en este momento. Probá más tarde.</p>
          </div>
        ) : (
          <div className="verif-caja">
            <div className="verif-pose">
              <span className="verif-pose-label">Tu gesto:</span>
              <strong>{estado.pose?.texto}</strong>
            </div>
            <ol className="verif-pasos">
              <li>Buscá buena luz y que se vea tu cara entera.</li>
              <li>Hacé el gesto y sacate la selfie en el momento.</li>
              <li>Tocá “Verificarme” y esperá unos segundos.</li>
            </ol>

            {vista && <img src={vista} alt="Tu selfie" className="verif-vista" />}
            {motivo && <p className="verif-motivo">{motivo}</p>}

            <div className="afinidad-pie">
              <label className="btn btn-outline btn-lg verif-camara">
                📸 {archivo ? 'Sacar otra' : 'Sacarme la selfie'}
                <input type="file" accept="image/*" capture="user" onChange={elegir} hidden />
              </label>
              <button className="btn btn-primary btn-lg" onClick={enviar} disabled={!archivo || enviando || estado.intentos_restantes <= 0}>
                {enviando ? 'Verificando…' : 'Verificarme'}
              </button>
            </div>
            <p className="verif-intentos">
              {estado.intentos_restantes > 0
                ? `Te quedan ${estado.intentos_restantes} intentos hoy.`
                : 'Ya usaste los intentos de hoy. Mañana podés probar de nuevo.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
